import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  openSocialModal,
  loadEditSocialData,
  deleteSocial,
} from "ActionsSocial";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { confirmAlert } from "react-confirm-alert"; // Import
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class ListItem extends Component {
  deleteSocialCallback(social) {
    confirmAlert({
      title: LocaleStrings.content_delete,
      message: LocaleStrings.social_delete_message,
      confirmLabel: LocaleStrings.content_ok,
      cancelLabel: LocaleStrings.content_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteSocial(
              this.props.session,
              this.props.social,
              (result) => {
                if (result.error) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess("Social deleted successfully!");
                  this.props.checkContentDashboardStatus(this.props.session);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  editSocialCallback(obj) {
    var social = this.props.social;
    this.props.loadEditSocialData(social);
    this.props.openSocialModal({
      showModal: true,
      linkFieldName: social.linktype,
      linkFieldLable:
        social.linktype[0].toUpperCase() + social.linktype.slice(1),
    });
  }

  render() {
    var { social } = this.props;
    return social.linktype != "linkedin" && social.linktype != "facebook" ? (
      <tr key={social.sociallinkid}>
        <td>
          <div className="pl-4">{social.linktype}</div>
        </td>
        <td>
          <div className="pl-4">{social.link}</div>
        </td>
        <td>
          <div className="action-button-area">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editSocialCallback.bind(this)}
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            <div className="action-button vcenter">
              <button
                className="i-custom-table-delete"
                onClick={this.deleteSocialCallback.bind(this)}
              >
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    ) : (
      <tr></tr>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
  };
}
export default connect(mapStateToProps, {
  openSocialModal,
  showError,
  showSuccess,
  loadEditSocialData,
  deleteSocial,
  checkContentDashboardStatus,
})(ListItem);
